import React from 'react';
import { IProps as IBlockProps } from './FiftyFiftyAccordionBlock.interface';
import { FiftyFiftyAccordionBlock } from './FiftyFiftyAccordionBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';
import * as translation from '@/utils/TranslationComponent/translation.utilities';

export interface IBlockInputProps {
    heading?: string;
    image?: any;
    imageDescription?: string;
    items?: {
        id: string;
        title: string;
        content: string;
    }[];
    mediaPosition?: 'left' | 'right';
    background?: ThemeColors;
    [key: string]: any;
}

const mapInputToProps = (input: IBlockInputProps): IBlockProps => {
    const {
        heading,
        image,
        imageDescription,
        items,
        mediaPosition,
        background,
        ...rest
    } = input;

    return {
        heading: heading,
        image: image ? translation.mapImageProps(image) : undefined,
        caption: imageDescription || undefined,
        accordionItems: items?.map((item) => ({
            value: item.id,
            title: item.title,
            content: item.content,
        })),
        mediaPosition: mediaPosition || 'right',
        backgroundColor: background || 'white',
        ...rest,
    } as IBlockProps; // Ensure the return type matches
};

const FiftyFiftyVideoBlockTranslation: React.FC<IBlockInputProps> = (inputProps) => (
    <TranslationComponent
        inputProps={inputProps}
        TargetComponent={FiftyFiftyAccordionBlock}
        mapProps={mapInputToProps}
    />
);

export default FiftyFiftyVideoBlockTranslation;